import React from 'react';
import {
  injectIntl,
} from 'react-intl';

export default injectIntl(({intl}) => {
  document.title = intl.formatMessage({id: "title"});
  return null;
});
